import { IUserAuthResponse } from 'types'
import callApi, { ENDPOINTS } from 'utils/api/callApi'

/**
 * Logs the user in via email and password
 * @method POST
 */
export const credentialsLogin = (args: {
  email?: string
  password?: string
}): Promise<IUserAuthResponse> => {
  const { email, password } = args || {}

  return callApi({
    endpoint: ENDPOINTS.signIn,
    method: 'POST',
    body: { userLogin: { email, password } },
  })
}

/**
 * Logs out the user
 * @method GET
 */
export const signOut = (): Promise<IUserAuthResponse> => {
  return callApi({
    endpoint: ENDPOINTS.signOut,
  })
}
